<script setup lang="ts">
withDefaults(defineProps<{
  as?: string
  variant?: 'soft' | 'strong' | 'floating'
  interactive?: boolean
}>(), { as: 'div', variant: 'soft', interactive: false })
</script>

<template>
  <component :is="as" class="vf-glass-container" :class="[`vf-glass-container--${variant}`, { 'is-interactive': interactive }]">
    <slot />
  </component>
</template>
